import { render, staticRenderFns } from "./16SettlementOfAccount.vue?vue&type=template&id=a4dbe9dc&"
import script from "./16SettlementOfAccount.vue?vue&type=script&lang=js&"
export * from "./16SettlementOfAccount.vue?vue&type=script&lang=js&"
import style0 from "./16SettlementOfAccount.vue?vue&type=style&index=0&id=a4dbe9dc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports